var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "org-tree-container" }, [
    _c(
      "div",
      {
        staticClass: "org-tree",
        class: { horizontal: _vm.horizontal, collapsable: _vm.collapsable }
      },
      [
        _c("org-tree-node", {
          attrs: {
            data: _vm.data,
            props: _vm.props,
            horizontal: _vm.horizontal,
            "label-style": _vm.labelStyle,
            collapsable: _vm.collapsable,
            "render-content": _vm.renderContent,
            "label-class-name": _vm.labelClassName
          },
          on: {
            "on-expand": function(e, data) {
              _vm.$emit("on-expand", e, data)
            },
            "on-node-click": function(e, data) {
              _vm.$emit("on-node-click", e, data)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }